export default "__VITE_ASSET__CqOt0KQ$__"